import React, { useState } from 'react';

const SearchAutoSuggest = ({ suggestions, searchTerm, setSeachTerm, disabled }) => {
  const [dropdown, setDropdown] = useState(false);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);

  const handleInputSearch = (event) => {
    setSeachTerm(event.target.value);
    const tempSearchTerm = event.target.value;
    if (event.target.value.length === 0) {
      setFilteredSuggestions([]);
      setDropdown(false);
    } else {
      const filtered = suggestions.filter(item => item.toLowerCase().includes(tempSearchTerm.toLowerCase()));
      if (filtered.length > 0) {
        setDropdown(true);
      } else {
        setDropdown(false);
      }
      setFilteredSuggestions(filtered);
    }
  }

  return (
    <div className={`dropdown ${dropdown ? 'is-active' : ''}`} style={{width: '100%'}}>
      <div className="dropdown-trigger"  style={{width: '100%'}}>
        <div className="field">
          <p className="control is-expanded has-icons-right">
            <input disabled={disabled} type="search" className="input" onChange={(event) => handleInputSearch(event)} value={searchTerm} />
            <span className="icon is-small is-right">
              <i className="fas fa-search"></i>
            </span>
          </p>
        </div>
      </div>
      {dropdown &&
        <div className="dropdown-menu pt-0 mt-0" id="dropdown-menu" role="menu">
          <div className="dropdown-content">
            {filteredSuggestions.map((suggestion, index) =>
              <a href="/" key={`${index}-${index}`} className="dropdown-item"
                onClick={(e) => {
                  e.preventDefault();
                  setDropdown(false);
                  setSeachTerm(suggestion);
                }}>
                {suggestion}
              </a>
            )}
          </div>
        </div>
      }
    </div>
  )
}

export default SearchAutoSuggest;